import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AudioProvider } from "@/context/AudioContext";
import LandingPage from "@/pages/LandingPage";
import ABCDModule from "@/pages/ABCDModule";
import CountingModule from "@/pages/CountingModule";
import TablesModule from "@/pages/TablesModule";
import ProgressDashboard from "@/pages/ProgressDashboard";
import MusicControl from "@/components/MusicControl";

// App Router - All routes are now public (no login required)
function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/learn/abcd" element={<ABCDModule />} />
      <Route path="/learn/counting" element={<CountingModule />} />
      <Route path="/learn/tables" element={<TablesModule />} />
      <Route path="/progress" element={<ProgressDashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AudioProvider>
        <div className="bubbles-bg">
          <div className="bubble w-20 h-20 bg-seagreen/20 top-[10%] left-[5%]" style={{ animationDelay: '0s' }} />
          <div className="bubble w-32 h-32 bg-teal/20 top-[30%] right-[10%]" style={{ animationDelay: '2s' }} />
          <div className="bubble w-16 h-16 bg-spark/20 bottom-[20%] left-[15%]" style={{ animationDelay: '4s' }} />
          <div className="bubble w-24 h-24 bg-mint/30 bottom-[40%] right-[20%]" style={{ animationDelay: '1s' }} />
        </div>
        <AppRouter />
        <MusicControl />
        <Toaster position="top-center" richColors />
      </AudioProvider>
    </BrowserRouter>
  );
}

export default App;
